import {
	ElementRef,
	Injectable,
	Renderer2,
	RendererStyleFlags2,
} from '@angular/core';

@Injectable()
export class ColumnModelConfigViewProvider {
	private readonly GAP_PX = 48 + 8;
	private readonly PANEL_HEADER = 48;
	private readonly ALERT = 56;

	public adjustHeights(elemRef: ElementRef, renderer: Renderer2): void {
		const modalContent =
			elemRef.nativeElement.querySelector('.app-modal-content');

		const columnList = document.querySelector(
			'.app-column-model-config-modal .app-subscription-column-config'
		) as HTMLElement | null;

		if (!columnList) {
			return;
		}

		const columnListHeight =
			modalContent.offsetHeight - this.GAP_PX - this.PANEL_HEADER - this.ALERT;

		renderer.setStyle(
			columnList,
			'--max-height-columns',
			`${columnListHeight}px`,
			RendererStyleFlags2.DashCase
		);
	}
}
